import { getEntryData as getEntryDataFromLib } from '@/lib/customer-data';

export const getEntryData = async (serverTime: string) => {
    return getEntryDataFromLib(serverTime);
};
